export var HAWKINS_URL_PROD = 'https://hawkins-professional.prod.netflix.net';
// Source of truth: https://www.w3.org/TR/uievents-key/#named-key-attribute-values.
// Also see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
export var KeyAttributeValue = {
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_UP: 'ArrowUp',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SPACE: ' ',
    TAB: 'Tab',
};
export var KeyboardEvents;
(function (KeyboardEvents) {
    KeyboardEvents[KeyboardEvents["onBackspace"] = 8] = "onBackspace";
    KeyboardEvents[KeyboardEvents["onComma"] = 188] = "onComma";
    KeyboardEvents[KeyboardEvents["onDown"] = 40] = "onDown";
    KeyboardEvents[KeyboardEvents["onEnter"] = 13] = "onEnter";
    KeyboardEvents[KeyboardEvents["onEsc"] = 27] = "onEsc";
    KeyboardEvents[KeyboardEvents["onLeft"] = 37] = "onLeft";
    KeyboardEvents[KeyboardEvents["onRight"] = 39] = "onRight";
    KeyboardEvents[KeyboardEvents["onShift"] = 16] = "onShift";
    KeyboardEvents[KeyboardEvents["onSpace"] = 32] = "onSpace";
    KeyboardEvents[KeyboardEvents["onTab"] = 9] = "onTab";
    KeyboardEvents[KeyboardEvents["onUp"] = 38] = "onUp";
})(KeyboardEvents || (KeyboardEvents = {}));
//# sourceMappingURL=constants.js.map